import { render, staticRenderFns } from "./oneCol.vue?vue&type=template&id=50bb6d53&scoped=true&"
import script from "./oneCol.vue?vue&type=script&lang=js&"
export * from "./oneCol.vue?vue&type=script&lang=js&"
import style0 from "./oneCol.vue?vue&type=style&index=0&id=50bb6d53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bb6d53",
  null
  
)

export default component.exports